import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from "axios";
import OutsideClickHandler from 'react-outside-click-handler';
import core from '../../core';
import useT from '../../i18n/useT';

const AddNewBooking = ({formData, setFormData, show, setShow, submit, type, loading}) => {
    const t = useT();
    const [vinList, setVinList] = useState([]);
    const [filteredVinList, setFilteredVinList] = useState([]);
    const [showVinList, setShowVinList] = useState(false);
    const [containersList, setConstainerList] = useState([]);
    const [filteredContainersList, setFilteredConstainerList] = useState([]);
    const [showContainersList, setShowContainers] = useState(false);
    const [boats, setBoats] = useState([]);

    useEffect(() => {
        axios('/api/vin-codes/booking')
            .then((res) => {
                setVinList([...res.data.data]);
                setFilteredVinList([...res.data.data]);
            })
            .catch((err) => {
                
            })
        axios('/api/containers-list/booking')
            .then((res) => {
                setConstainerList([...res.data.data]);
                setFilteredConstainerList([...res.data.data]);
            })
            .catch((err) => {
                
            })
        axios('/api/boats?limit=50&page=1&keyword=&asc=desc&status=us_port&sort_by=id')
            .then((res) => {
                setBoats([...res.data.data]);
            })
            .catch((err) => {
                
            })
    }, [])

    return(
        <Modal show={show} onHide={() => setShow(false)} centered size='xl'>
            <Modal.Header closeButton><h3>{type === "edit" ? t("booking.editTitle") : t("booking.addTitle")}</h3></Modal.Header>
            <Modal.Body>
                <form onSubmit={submit} className='row'>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group' style={{position: "relative"}}>
                            <label>VIN</label>
                            <input type='text' onClick={() => setShowVinList(true)} placeholder={t("booking.enterVin")} className='form-control' value={formData.vin} onChange={(e) => setFormData((prev) => ({...prev, vin: e.target.value}))}/>
                            {showVinList && <OutsideClickHandler onOutsideClick={() => setShowVinList(false)}>
                                    <div className='booking-vin-code-suggestions'>
                                        <div className='suggestions-filter' style={{marginBottom: "10px"}}>
                                            <input placeholder={t("booking.typeToFilter")} type='text' className='form-control' onChange={(e) => {
                                                const data = vinList.filter((vincode) => vincode.vin.toLowerCase().includes(e.target.value.toLowerCase()));
                                                setFilteredVinList(data);
                                            }} />
                                        </div>
                                        {
                                            filteredVinList.map((car, i) => <div key={i} onClick={() => {
                                                setFormData((prev) => ({...prev, vin: car.vin, delivery_location: car.destination_port, loading_port: car.us_port, delivery_location: "Poti", car_details: `${car.mark} ${car.model} ${car.year}`, user_id: car.dealer_id, lot_number: car.lot_number, container_receiver: car.receiver_fullname, buyer_fullname: car.buyer}))
                                                setShowVinList(false);
                                            }}>{car.vin}</div>)
                                        }
                                        {
                                            filteredVinList.length == 0 && <div style={{textAlign: "center", width: "100%"}}>{t("booking.carsNotFound")}</div>
                                        }
                                    </div>
                                </OutsideClickHandler>}
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.buyerFullname")}</label>
                            <input type='text' placeholder={t("booking.enterBuyer")} className='form-control' value={formData.buyer_fullname} onChange={(e) => setFormData((prev) => ({...prev, buyer_fullname: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.bookingNumber")}</label>
                            <input type='text' placeholder={t("booking.enterBookingNumber")} className='form-control' value={formData.booking_number} onChange={(e) => setFormData((prev) => ({...prev, booking_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group' style={{position: "relative"}}>
                            <label>{t("booking.container")}</label>
                            <input type='text' onClick={() => setShowContainers(true)} placeholder={t("booking.enterContainerNumber")} className='form-control' value={formData.container} onChange={(e) => setFormData((prev) => ({...prev, container: e.target.value}))}/>
                            {showContainersList && <OutsideClickHandler onOutsideClick={() => setShowContainers(false)}>
                                    <div className='booking-vin-code-suggestions'>
                                        <div className='suggestions-filter' style={{marginBottom: "10px"}}>
                                            <input placeholder={t("booking.typeToFilter")} type='text' className='form-control' onChange={(e) => {
                                                const data = containersList.filter((container) => container.container_number.toLowerCase().includes(e.target.value.toLowerCase()))
                                                setFilteredConstainerList(data);
                                            }} />
                                        </div>
                                        {
                                            filteredContainersList.map((container) => <div key={container.container_number} onClick={() => {
                                                setFormData((prev) => ({...prev, container_number: container.container_number, boat_id: container.boat_id, boat_name: container.boat_name}))
                                            }}>{container.container_number}</div>)
                                        }
                                        {
                                            filteredContainersList.length == 0 && <div style={{textAlign: "center", width: "100%"}}>{t("booking.containerNotFound")}</div>
                                        }
                                    </div>
                                </OutsideClickHandler>}
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.containerReceiver")}</label>
                            <input type='text' placeholder={t("booking.enterReceiver")} className='form-control' value={formData.container_receiver} onChange={(e) => setFormData((prev) => ({...prev, container_receiver: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.deliveryLocation")}</label>
                            <select type='text' placeholder='Enter receiver' className='form-control' value={formData.delivery_location} onChange={(e) => setFormData((prev) => ({...prev, delivery_location: e.target.value}))}>
                                <option>{t("booking.selectLocation")}</option>
                                <option value={"Poti"}>Poti</option>
                                <option value={"Batumi"}>Batumi</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.line")}</label>
                            <select type='text' placeholder='Enter receiver' className='form-control' value={formData.line} onChange={(e) => setFormData((prev) => ({...prev, line: e.target.value}))}>
                                <option>{t("booking.selectLine")}</option>
                                <option value={"Evergreen"}>Evergreen</option>
                                <option value={"Maersk"}>Maersk</option>
                                <option value={"MSC"}>MSC</option>
                                <option value={"Hapag-Lloyd"}>Hapag-Lloyd</option>
                                <option value={"CMA CGM"}>CMA CGM</option>
                                <option value={"ONE"}>ONE</option>
                                <option value={"COSCO"}>COSCO</option>
                                <option value={"ZIM"}>ZIM</option>
                                <option value={"TURKON"}>TURKON</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.loadingPort")}</label>
                            <select type='text' placeholder='Enter receiver' className='form-control' value={formData.loading_port} onChange={(e) => setFormData((prev) => ({...prev, loading_port: e.target.value}))}>
                                <option>{t("booking.selectLoadingPort")}</option>
                                <option value={"Port of WA Washington"}>Port of WA Washington</option>
                                <option value={"Port of CA California"}>Port of CA California</option>
                                <option value={"Port of TX Texas"}>Port of TX Texas</option>
                                <option value={"Port of GA Georgia"}>Port of GA Georgia</option>
                                <option value={"Port of NJ New Jersey"}>Port of NJ New Jersey</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.terminal")}</label>
                            <input type='text' placeholder={t("booking.enterTerminal")} className='form-control' value={formData.terminal} onChange={(e) => setFormData((prev) => ({...prev, terminal: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group' style={{position: "relative"}}>
                            <label>{t("booking.lotStock")}</label>
                            <input type='text' placeholder={t("booking.enterLotStock")} className='form-control' value={formData.lot_number} onChange={(e) => setFormData((prev) => ({...prev, lot_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.markModelYear")}</label>
                            <input type='text' placeholder={t("booking.enterMarkModelYear")} className='form-control' value={formData.car_details} onChange={(e) => setFormData((prev) => ({...prev, car_details: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.userId")}</label>
                            <input type='text' placeholder={t("booking.enterUserId")} className='form-control' value={formData.user_id} onChange={(e) => setFormData((prev) => ({...prev, user_id: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("booking.boat")}</label>
                            <select className='form-control' value={formData.boat_id} onChange={(e) => {
                                setFormData((prev) => ({...prev, boat_id: e.target.value, boat_name: e.target.options[e.target.selectedIndex].text}))
                            }}>
                                <option>{t("booking.selectBoat")}</option>
                                {
                                    boats.map((boat) => <option key={boat.identification_code} value={boat.identification_code}>{boat.name}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    {type === "edit" && <>
                        <div className='col-md-4 mt-4'>
                            <div className='form-group'>
                                <label>{t("booking.estimatedArrivalDate")}</label>
                                <input type='date' className='form-control' value={formData.estimated_arrival_date ? core.formdatDate(formData.estimated_arrival_date, "yyyy-mm-dd") : ""} onChange={(e) => setFormData((prev) => ({...prev, estimated_arrival_date: e.target.value}))}/>
                            </div>
                        </div>
                        <div className='col-md-4 mt-4'>
                            <div className='form-group'>
                                <label>{t("booking.containerReceiveDate")}</label>
                                <input type='date' className='form-control' value={formData.container_receive_date ? core.formdatDate(formData.container_receive_date, "yyyy-mm-dd") : ""} onChange={(e) => setFormData((prev) => ({...prev, container_receive_date: e.target.value}))}/>
                            </div>
                        </div>
                        <div className='col-md-4 mt-4'>
                            <div className='form-group'>
                                <label>{t("booking.containerLoadedDate")}</label>
                                <input type='date' className='form-control' value={formData.container_loaded_date ? core.formdatDate(formData.container_loaded_date, "yyyy-mm-dd") : ""} onChange={(e) => setFormData((prev) => ({...prev, container_loaded_date: e.target.value}))}/>
                            </div>
                        </div>
                        <div className='col-md-4 mt-4'>
                            <div className='form-group'>
                                <label>{t("booking.estimatedOpeningDate")}</label>
                                <input type='date' className='form-control' value={formData.est_opening_date ? core.formdatDate(formData.est_opening_date, "yyyy-mm-dd") : ""} onChange={(e) => setFormData((prev) => ({...prev, est_opening_date: e.target.value}))}/>
                            </div>
                        </div>
                        <div className='col-md-4 mt-4'>
                            <div className='form-group'>
                                <label>{t("booking.openingDate")}</label>
                                <input type='date' className='form-control' value={formData.open_date ? core.formdatDate(formData.open_date, "yyyy-mm-dd") : ""} onChange={(e) => setFormData((prev) => ({...prev, open_date: e.target.value}))}/>
                            </div>
                        </div>
                    </>}
                    <Modal.Footer style={{marginTop: "1.5rem"}}>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : type === "add" ? t("common.addNew") : t("common.save")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewBooking